import { VasColor16, VasPlatnoe16, VasPremium16, VasTop16, Vas16 } from '@cian/ui-kit';
import React from 'react';

import { EVas } from '../../types/vas';

interface IVasIconProps {
  type: EVas;
}

export function VasIcon({ type }: IVasIconProps) {
  switch (type) {
    case EVas.Auction:
      return <Vas16 color="warning_100" />;
    case EVas.Colorized:
      return <VasColor16 color="warning_100" />;
    case EVas.Paid:
      return <VasPlatnoe16 color="warning_100" />;
    case EVas.Premium:
      return <VasPremium16 color="warning_100" />;
    case EVas.Top:
      return <VasTop16 color="warning_100" />;
    default:
      return null;
  }
}
